import type { BlockSettings } from '@geoic/shared';
import { Input } from '@/components/ui/Field.js';
import { MediaPicker } from '@/components/media/MediaPicker.js';
import { EnumSelect, FieldGroup } from './BlockFields.js';

export type BlockAppearanceProps = {
  value: BlockSettings;
  onChange: (value: BlockSettings) => void;
};

/**
 * Ko'rinish sozlamalari — 31 blokda BIR XIL (D4).
 *
 * Har bir blok formasida takrorlanmaydi: sxemada ham `blockCommonSchema`
 * ichida, bu yerda ham bitta panel.
 */
export function BlockAppearance({ value, onChange }: BlockAppearanceProps) {
  function set<K extends keyof BlockSettings>(key: K, next: BlockSettings[K]): void {
    onChange({ ...value, [key]: next });
  }

  return (
    <FieldGroup title="Ko‘rinish">
      <div className="grid grid-cols-2 gap-3">
        <EnumSelect
          label="Yuqoridagi bo‘shliq"
          value={value.paddingTop}
          options={SPACING}
          onChange={(next) => set('paddingTop', next)}
        />
        <EnumSelect
          label="Pastdagi bo‘shliq"
          value={value.paddingBottom}
          options={SPACING}
          onChange={(next) => set('paddingBottom', next)}
        />
      </div>

      <EnumSelect
        label="Fon"
        value={value.background}
        options={[
          { value: 'white', label: 'Oq' },
          { value: 'grey', label: 'Kulrang' },
          { value: 'dark', label: 'To‘q' },
          { value: 'primary', label: 'Asosiy rang' },
          { value: 'image', label: 'Rasm' },
        ]}
        onChange={(next) => set('background', next)}
      />

      {value.background === 'image' && (
        <MediaPicker
          label="Fon rasmi"
          value={value.backgroundImage}
          onChange={(next) => set('backgroundImage', next)}
          hint="Matn o‘qilishi uchun rasm ustiga to‘q parda qo‘yiladi"
        />
      )}

      <EnumSelect
        label="Konteyner kengligi"
        value={value.containerWidth}
        options={[
          { value: 'default', label: 'Odatiy' },
          { value: 'wide', label: 'Keng' },
          { value: 'full', label: 'Butun ekran' },
        ]}
        onChange={(next) => set('containerWidth', next)}
      />

      <Input
        label="Langar (anchor)"
        value={value.anchorId}
        placeholder="xizmatlar"
        onChange={(event) => set('anchorId', event.target.value.toLowerCase())}
        hint="To‘ldirilsa blokka to‘g‘ridan-to‘g‘ri havola berish mumkin: /sahifa#xizmatlar"
        error={
          value.anchorId && !/^[a-z0-9-]*$/.test(value.anchorId)
            ? 'Faqat kichik lotin harflari, raqam va defis'
            : undefined
        }
      />
    </FieldGroup>
  );
}

const SPACING = [
  { value: 'none' as const, label: 'Yo‘q' },
  { value: 'sm' as const, label: 'Kichik' },
  { value: 'md' as const, label: 'O‘rtacha' },
  { value: 'lg' as const, label: 'Katta' },
];
